class BlogFacetFilters {
   constructor() {
    this.container = document.getElementById("BlogGridContainer");
    if (!this.container) return;

    this.sectionId = this.container.dataset.id;
    if (!this.sectionId) return;

    this.init();
  }

  init() {
    document.querySelectorAll(".facets_tags--blog .facets-tag__button").forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        const url = event.currentTarget.getAttribute("href");
        this.renderPage(url, event.currentTarget);
      });
    });
  }

  renderPage(url, activeButton) {
    const fetchUrl = `${url}${url.includes("?") ? "&" : "?"}section_id=${this.sectionId}`;
    console.log("fetchUrl",fetchUrl);

    this.container.classList.add("loading");

    fetch(fetchUrl)
      .then((res) => res.text())
      .then((html) => {
        const parsed = new DOMParser().parseFromString(html, "text/html");

        const newGrid = parsed.getElementById("BlogGridContainer");
        if (!newGrid) return;

        this.container.innerHTML = newGrid.innerHTML;
        this.container.classList.remove("loading");

        history.pushState({}, "", url);
        
        this.updateActiveState(activeButton);

        if (
          document.querySelector(".js-load-more") ||
          document.querySelector(".js-infinite-scroll")
        ) {
          if (typeof loadMore === "function") loadMore();
        }
      })
      .catch((err) => {
        console.error("Blog filter error:", err);
        this.container.classList.remove("loading");
      });
  }

  updateActiveState(activeButton) {
    document
      .querySelectorAll(".facets_tags--blog .facets-tag__button")
      .forEach((btn) => btn.classList.remove("active"));

    if (activeButton) activeButton.classList.add("active");
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new BlogFacetFilters();
});